/*
 * Copyright (c) 2024, Behçet Atalay
 * All rights reserved.
 *
 * @project   kaan-web
 * @author    Behçet Atalay
 * @site      https://www.technobecet.com
 * @date      18 February 2024
 */
const TextFeaturePanel = () => {
  return (
    <div className='max-w-[1920px] pt-10 sm:pt-20 px-4 sm:px-6 xl:px-10'>
      <div className='lg:text-center'>
        <h1 className='text-2xl text-dark-50 font-loos font-semibold tracking-wide uppercase text-center'>
          INNOVATIVE, CREATIVE PRODUCTION STUDIO
        </h1>
        <p className='mt-4 font-loos text-xl text-dark-200 lg:mx-auto text-center'>
          Let us utilize our creative expertise and production prowess to
          meticulously design a compelling narrative specifically tailored to
          meet and exceed the unique requirements and aspirations of your
          esteemed business.
        </p>
      </div>
      {/* <div className='mt-8 py-3 px-8 flex justify-center'>
        <a
          href='#'
          className='text-center text-base font-medium text-dark-200 hover:text-dark-50 hover:border-b-2 hover:border-dark-50'
        >
          SEE MORE
        </a>
      </div> */}
    </div>
  );
};
export default TextFeaturePanel;
